import { RestSlice } from 'src/redux/rest.slice';
import { Authority } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const haulerAuthoritySlice = new RestSlice<Authority>(
	localizationService.getLocalizedString('haulerPortal.authority.authorities'),
	Resource.Authorities
);
export default haulerAuthoritySlice.rests.reducer;
